var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',{staticClass:"mt25",attrs:{"type":"number","placeholder":_vm.$t('Number of cutlery *'),"validations":[{
              condition: this.$v.cutleryQty.$error && !this.$v.cutleryQty.required,
              text: this.$t('Field is required')
            }]},on:{"blur":function($event){return _vm.$v.cutleryQty.$touch()}},model:{value:(_vm.cutleryQty),callback:function ($$v) {_vm.cutleryQty=$$v},expression:"cutleryQty"}})}
var staticRenderFns = []

export { render, staticRenderFns }